
import React from 'react'

export default function ShipmentInfoComponent({ handleDelete, handleAdd, handlePlus, handleMinus, variantLists, ProductLists, categoryListItems, handlePackage, selectedInput, handleFormItemChange, PackageType, productItems, libraryData, shippingTypesDetails, handleChange, quoteData }: any) {

    return (

        <div className="w-full max-w-5xl mx-auto p-6 bg-white shadow-lg rounded-lg border border-gray-200 space-y-6">

            {/* Shipping Category */}
            <div>
                <label className="block text-xs font-semibold text-gray-700">Shipping Category <span className="text-red-500">*</span></label>

                <select
                    className="w-full px-3 py-2 border border-gray-300 text-xs rounded-lg bg-gray-50 focus:outline-none focus:ring-2 focus:ring-blue-500"
                    onChange={(event) => handleChange(event.target.value, 'category_id')}
                    value={quoteData?.category_id}
                >
                    <option>--Select--</option>
                    {shippingTypesDetails?.result?.items?.map((item, index) => (
                        <option value={item.ShippingTypeName} key={index}>{item.ShippingTypeName}</option>
                    ))}
                </select>

            </div>

            {/* Shipping Type */}
            <div>
                <label className="block text-xs font-semibold text-gray-700">Shipping Type <span className="text-red-500">*</span></label>

                <select
                    className="w-full px-3 py-2 border border-gray-300 text-xs rounded-lg bg-gray-50 focus:outline-none focus:ring-2 focus:ring-blue-500"
                    onChange={(event) => handleChange(event.target.value, 'code')}
                    value={quoteData?.code}
                >
                    <option>--Select--</option>
                    {libraryData?.result?.ShipmentType?.map((item, index) => (
                        <option value={item.Text} key={index}>{item.Text}</option>
                    ))}
                </select>

            </div>

            {/* Product Fields */}
            {productItems?.map((item: any, index: any) => (
                <div key={index} className="w-full bg-white shadow-xl rounded-lg p-4 mb-4">

                    {/* Package Type Selection */}
                    <div className="flex flex-col sm:flex-row items-center justify-between space-y-4 sm:space-x-4 pb-2">
                        {PackageType?.map((item: any, idx: any) => (
                            <div key={idx} className="flex items-center w-full">
                                <input
                                    type="radio"
                                    name={item?.name}
                                    checked={selectedInput == String(item?.name)}
                                    className="mx-3 h-3 rounded bg-opacity-0"
                                    onChange={(event) => {
                                        handlePackage(event)
                                        handleFormItemChange({ value: item?.name, idx: idx, field: 'packageType' })
                                    }}
                                    value={item?.name}
                                />
                                <div className="text-xs font-light">{item?.name}</div>
                            </div>
                        ))}
                    </div>

                    {/* Product and Variant Selection */}
                    <div className="grid gap-4 sm:grid-cols-2 md:grid-cols-3">
                        <div>
                            <label className="block text-xs font-semibold text-gray-700">Category <span className="text-red-500">*</span></label>
                            <select
                                className="w-full px-3 py-2 border border-gray-300 text-xs rounded-lg bg-gray-50 focus:outline-none focus:ring-2 focus:ring-blue-500"
                                onChange={(event) => handleFormItemChange({ value: event.target.value, idx: index, field: 'CategoryId' })}
                                value={item?.CategoryId}
                            >
                                <option>--Select--</option>
                                {categoryListItems?.result?.items?.map((category, idx) => (
                                    <option value={category.Id} key={idx}>{category.Name}</option>
                                ))}
                            </select>
                        </div>
                        <div>
                            <label className="block text-xs font-semibold text-gray-700">Product <span className="text-red-500">*</span></label>
                            <select
                                className="w-full px-3 py-2 border border-gray-300 text-xs rounded-lg bg-gray-50 focus:outline-none focus:ring-2 focus:ring-blue-500"
                                onChange={(event) => handleFormItemChange({ value: event.target.value, idx: index, field: 'LogisticsProductId' })}
                                value={item?.LogisticsProductId}
                            >
                                <option>--Select--</option>
                                {ProductLists?.result?.items?.map((product, idx) => (
                                    <option value={product.Id} key={idx}>{product.Name}</option>
                                ))}
                            </select>
                        </div>
                        <div>
                            <label className="block text-xs font-semibold text-gray-700">Variant <span className="text-red-500">*</span></label>
                            <select
                                className="w-full px-3 py-2 border border-gray-300 text-xs rounded-lg bg-gray-50 focus:outline-none focus:ring-2 focus:ring-blue-500"
                                onChange={(event) => handleFormItemChange({ value: event.target.value, idx: index, field: 'LogisticsVariantId' })}
                                value={item?.LogisticsVariantId}
                            >
                                <option>--Select--</option>
                                {variantLists?.result?.items?.map((variant, idx) => (
                                    <option value={variant.Id} key={idx}>{variant.Name}</option>
                                ))}
                            </select>
                        </div>
                    </div>

                    {/* Dangerous Goods and Item Details */}
                    <div className="grid gap-4 my-3">
                        <div className="w-full flex items-center">
                            <input
                                type="checkbox"
                                name="DangerousGoods"
                                className="h-5 w-5 border border-black border-opacity-50 rounded"
                                onChange={(event) => handleFormItemChange({ value: event.target.checked, idx: index, field: 'dangerous_goods' })}
                                checked={item?.dangerous_goods}
                            />
                            <label className="text-xs font-semibold text-gray-700 ml-2">Dangerous</label>
                        </div>

                        {/* Weight and Value Inputs */}
                        <div className="w-full">
                            <label className="block text-xs font-semibold text-gray-700">Approximate Weight</label>
                            <input
                                type="number"
                                className="w-full px-3 py-2 border border-gray-300 text-xs rounded-lg bg-gray-50 focus:outline-none focus:ring-2 focus:ring-blue-500"
                                onChange={(event) => handleFormItemChange({ value: event.target.value, idx: index, field: 'weight' })}
                                value={item?.weight}
                            />
                            <label className="block text-xs font-light text-right text-gray-500">in kg</label>
                        </div>
                        <div className="w-full">
                            <label className="block text-xs font-semibold text-gray-700">Approximate Value <span className="text-red-500">*</span></label>
                            <input
                                type="text"
                                className="w-full px-3 py-2 border border-gray-300 text-xs rounded-lg bg-gray-50 focus:outline-none focus:ring-2 focus:ring-blue-500"
                                onChange={(event) => handleFormItemChange({ value: event.target.value, idx: index, field: 'value' })}
                                value={item?.value}
                            />
                            <label className="block text-xs font-light text-right text-gray-500">in ₹</label>
                        </div>

                        {/* Custom Package Dimensions */}
                        {selectedInput === 'Custom Package' && (
                            <>
                                <div className="w-full">
                                    <label className="block text-xs font-semibold text-gray-700">Measure</label>
                                    <input
                                        type="number"
                                        className="w-full px-3 py-2 border border-gray-300 text-xs rounded-lg bg-gray-50 focus:outline-none focus:ring-2 focus:ring-blue-500"
                                        onChange={(event) => handleFormItemChange({ value: event.target.value, idx: index, field: 'measure' })}
                                        value={item?.measure}
                                    />
                                    <label className="block text-xs font-light text-right text-gray-500">in mm</label>
                                </div>
                                <div className="w-full">
                                    <label className="block text-xs font-semibold text-gray-700">Breadth</label>
                                    <input
                                        type="number"
                                        className="w-full px-3 py-2 border border-gray-300 text-xs rounded-lg bg-gray-50 focus:outline-none focus:ring-2 focus:ring-blue-500"
                                        onChange={(event) => handleFormItemChange({ value: event.target.value, idx: index, field: 'breadth' })}
                                        value={item?.breadth}
                                    />

                                    <label className="block text-xs font-light text-right text-gray-500">in mm</label>
                                </div>
                                <div className="w-full">
                                    <label className="block text-xs font-semibold text-gray-700">Height</label>
                                    <input
                                        type="number"
                                        className="w-full px-3 py-2 border border-gray-300 text-xs rounded-lg bg-gray-50 focus:outline-none focus:ring-2 focus:ring-blue-500"
                                        onChange={(event) => handleFormItemChange({ value: event.target.value, idx: index, field: 'Height' })}
                                        value={item?.Height}
                                    />
                                    <label className="block text-xs font-light text-right text-gray-500">in mm</label>
                                </div>
                                <div className="w-full">
                                    <label className="block text-xs font-semibold text-gray-700">Length</label>
                                    <input
                                        type="number"
                                        className="w-full px-3 py-2 border border-gray-300 text-xs rounded-lg bg-gray-50 focus:outline-none focus:ring-2 focus:ring-blue-500"
                                        onChange={(event) => handleFormItemChange({ value: event.target.value, idx: index, field: 'Length' })}
                                        value={item?.Length}
                                    />
                                    <label className="block text-xs font-light text-right text-gray-500">in mm</label>
                                </div>
                            </>
                        )}
                    </div>

                    {/* Additional Info */}
                    <div className="w-full">
                        <label className="block text-xs font-semibold text-gray-700">Additional Information</label>
                        <textarea
                            name="additionainfo"
                            className="w-full h-14 border border-gray-300 text-xs rounded-lg px-4 py-2 bg-gray-50 focus:outline-none focus:ring-2 focus:ring-blue-500"
                            onChange={(event) => handleFormItemChange({ value: event.target.value, idx: index, field: 'item_description' })}
                            value={item?.item_description}
                        />
                    </div>

                    {/* Action Buttons */}
                    <div className="flex flex-row justify-between items-center w-full space-y-4 pt-4">
                        <div className="flex space-x-2 items-center">
                            {/* Decrease Quantity Button */}
                            <svg
                                onClick={() => handleMinus(index, item?.quantity)}
                                fill="#6b7280" height="18" width="18" className="cursor-pointer mt-3" version="1.1" id="Layer_1"
                                viewBox="0 0 210.414 210.414">
                                <path d="M105.207,0C47.196,0,0,47.196,0,105.207c0,58.011,47.196,105.207,105.207,105.207 c58.011,0,105.207-47.196,105.207-105.207C210.414,47.196,163.218,0,105.207,0z M105.207,202.621 c-53.715,0-97.414-43.699-97.414-97.414c0-53.715,43.699-97.414,97.414-97.414c53.715,0,97.414,43.699,97.414,97.414 C202.621,158.922,158.922,202.621,105.207,202.621z" />
                                <path d="M155.862,101.31H54.552c-2.152,0-3.897,1.745-3.897,3.897c0,2.152,1.745,3.897,3.897,3.897h101.31 c2.152,0,3.897-1.745,3.897-3.897C159.759,103.055,158.014,101.31,155.862,101.31z" />
                            </svg>
                            {/* Quantity Input */}
                            <div className="flex flex-col ">
                                <label className="block text-xs font-semibold text-gray-700">Quantity <span className="text-red-500">*</span></label>
                                <input
                                    type="number"
                                    className="w-full text-center px-3 py-2 border border-gray-300 rounded-lg text-xs"
                                    onChange={(event) => handleFormItemChange({ value: event.target.value, idx: index, field: 'quantity' })}
                                    value={item?.quantity}
                                />
                            </div>
                            {/* Increase Quantity Button */}
                            <svg
                                onClick={() => handlePlus(index, item?.quantity)}
                                fill="#6b7280" width="18" height="18" className="cursor-pointer mt-3" viewBox="0 0 32 32" version="1.1">
                                <path d="M16 0c-8.836 0-16 7.163-16 16s7.163 16 16 16c8.837 0 16-7.163 16-16s-7.163-16-16-16zM16 30.032c-7.72 0-14-6.312-14-14.032s6.28-14 14-14 14 6.28 14 14-6.28 14.032-14 14.032zM23 15h-6v-6c0-0.552-0.448-1-1-1s-1 0.448-1 1v6h-6c-0.552 0-1 0.448-1 1s0.448 1 1 1h6v6c0 0.552 0.448 1 1 1s1-0.448 1-1v-6h6c0.552 0 1-0.448 1-1s-0.448-1-1-1z"></path>
                            </svg>
                        </div>

                        {/* Add Button */}
                        <div className="w-[100px] flex justify-end space-x-1">

                            {(index + 1) === productItems.length ? <button onClick={() => handleAdd()} className="text-light p-1 text-xs bg-primary rounded">
                                <svg xmlns="http://www.w3.org/2000/svg" fill="currentColor" viewBox="0 0 24 24" width="14" height="14">

                                    <path d="M12 5v14m-7-7h14" stroke="currentColor" stroke-width="2" fill="none" />
                                </svg>
                            </button> : ''}
                            {productItems.length > 1 && (index + 1) === productItems.length && (
                                <button
                                    onClick={() => handleDelete(productItems, index)}
                                    className="text-light p-1 text-xs bg-primary rounded"
                                >
                                    <svg xmlns="http:www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 24 24" fill="currentColor"><path d="M17 6H22V8H20V21C20 21.5523 19.5523 22 19 22H5C4.44772 22 4 21.5523 4 21V8H2V6H7V3C7 2.44772 7.44772 2 8 2H16C16.5523 2 17 2.44772 17 3V6ZM18 8H6V20H18V8ZM13.4142 13.9997L15.182 15.7675L13.7678 17.1817L12 15.4139L10.2322 17.1817L8.81802 15.7675L10.5858 13.9997L8.81802 12.232L10.2322 10.8178L12 12.5855L13.7678 10.8178L15.182 12.232L13.4142 13.9997ZM9 4V6H15V4H9Z"></path></svg>
                                </button>
                            )}

                        </div>
                    </div>
                </div>
            ))}
        </div>


    )
}